import React from "react";
import PropTypes from "prop-types";
import Pagination from "antd/lib/pagination";
import { useTheme } from "@/components/ThemeProvider";

import "./Paginator.less";

const MIN_ITEMS_PER_PAGE = 5;

const Paginator = ({
  page,
  showPageSizeSelect,
  pageSize,
  onPageSizeChange,
  totalCount,
  onChange,
}) => {
  const { isDarkMode } = useTheme();

  if (totalCount <= (showPageSizeSelect ? MIN_ITEMS_PER_PAGE : pageSize)) {
    return null;
  }

  return (
    <div className={`paginator-container ${isDarkMode ? 'dark-mode' : ''}`}>
      <Pagination
        showSizeChanger={showPageSizeSelect}
        pageSizeOptions={["5", "10", "20", "50", "100"]}
        onShowSizeChange={(_, size) => onPageSizeChange(size)}
        defaultCurrent={page}
        pageSize={pageSize}
        total={totalCount}
        onChange={onChange}
      />
    </div>
  );
};

Paginator.propTypes = {
  page: PropTypes.number.isRequired,
  showPageSizeSelect: PropTypes.bool,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onPageSizeChange: PropTypes.func,
  onChange: PropTypes.func,
};

Paginator.defaultProps = {
  showPageSizeSelect: false,
  onChange: () => {},
  onPageSizeChange: () => {},
};

export default Paginator;